// Arquivo .zip para o contador (E8): o resumo em PDF e as fotos (ou PDFs) das
// notas das despesas e dos documentos das cargas do período, com nomes que
// dizem o que são ("notas/2026-09-05 - Diesel - MDT7J86 - 1.800,00.jpg").
import { zipSync } from 'fflate';
import { numeroBR } from './formato.js';

const EXTENSOES = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/heic': 'heic', 'application/pdf': 'pdf' };

function extensaoDoAnexo(a) {
  return EXTENSOES[a.mime] ?? (/\.([a-z0-9]{2,5})$/i.exec(a.storage_path ?? '')?.[1]?.toLowerCase() || 'bin');
}

// Só letras, números, espaço e . , - ( ) _ (os nomes abrem em qualquer computador).
function limpar(texto) {
  return String(texto ?? '').normalize('NFC').replace(/[^\p{L}\p{N} .,()_-]+/gu, ' ').replace(/\s+/g, ' ').trim();
}

// O nome de cada arquivo dentro do .zip, sem repetir.
export function nomesNoPacote(itens) {
  const usados = new Set();
  return itens.map((x) => {
    const partes = x.despesa
      ? ['notas', [x.despesa.data, x.despesa.categoria, x.despesa.veiculo, x.despesa.fornecedor, numeroBR(x.despesa.valor, { casas: 2 })]]
      : ['cargas', [x.carga.carregamento, x.carga.cliente || 'carga', numeroBR(x.carga.bruto, { casas: 2 })]];
    const base = `${partes[0]}/${partes[1].filter(Boolean).map(limpar).filter(Boolean).join(' - ')}`;
    const ext = extensaoDoAnexo(x.anexo);
    let nome = `${base}.${ext}`;
    for (let i = 2; usados.has(nome); i++) nome = `${base} (${i}).${ext}`;
    usados.add(nome);
    return nome;
  });
}

// arquivos: [{ nome, dados: Uint8Array }] → Blob do .zip. Sem comprimir por
// padrão (fotos e PDFs já são comprimidos); planilhas e textos: `nivel` 6.
export function montarZip(arquivos, { nivel = 0 } = {}) {
  const mapa = {};
  for (const a of arquivos) mapa[a.nome] = [a.dados, { level: nivel }];
  return new Blob([zipSync(mapa)], { type: 'application/zip' });
}

export function nomeDoZipDoContador({ de, ate, regime }) {
  const mes = (d) => d.slice(0, 7);
  return `contador-${mes(de) === mes(ate) ? mes(de) : `${mes(de)}-a-${mes(ate)}`}-${regime}.zip`;
}
